import React from 'react'

import s from './FiltersContainer.scss'


const FiltersContainer = ({ children }) => (
  <div className={s.filtersContainer}>{children}</div>
)


export default FiltersContainer
